"use client";
import React from "react";
import { jointImgUploadByUser } from "@/lib/commonService";

import AnswerItem from "./AnswerItem";
import stl from "./answerItem.module.scss";
import ProductAnswerClient, {
    IProductAnserClientProps,
} from "./ProductAnswerClient";
import WithPhotoSwiper, {
    PhotoSwiperTitle,
    WrapperProps,
} from "@/src/components/Upload/WithPhotoSwiper";
import {
    IInitedInfo,
    IProductDetailsInfo,
} from "@/store/modules/productDetails";
import { useTranslation } from "@/src/i18n/client";

export interface IProps extends IProductAnserClientProps, IPropsFromPage {
    askList: any[];
    askNum: number;
    id: number;
}

export interface IPropsFromPage {
    packageInfo: any;
    language: string;
    userInfo: any;
    productDetail: Partial<IInitedInfo & IProductDetailsInfo>;
}

type IContainerProps = WrapperProps<IProps>;

const ProductAnswer: React.FC<IContainerProps> = (props) => {
    const {
        askNum,
        askList,
        mapPhotoSwiperImg,
        openSetPhotoSwiper,
        id,
        packageInfo,
        productDetail,
    } = props;
    const reviewList =
        askList?.map((item: any) => {
            return {
                reviews_photo: item.reviews_photo
                    ? jointImgUploadByUser(item.reviews_photo)
                    : "",
                title: PhotoSwiperTitle(item, true),
            };
        }) ?? [];
    const imgs: any = mapPhotoSwiperImg?.(reviewList, "reviews_photo");
    const { t } = useTranslation("review");
    return (
        <ProductAnswerClient
            askNum={askNum}
            id={id}
            isPackage={!!(packageInfo?.isPackage && productDetail.meedPackage)}
            userInfo={props.userInfo}
        >
            {askNum > 0 ? (
                <div style={{ marginBottom: "0.4rem" }}>
                    {askList.map((item: any, index: number) => (
                        <AnswerItem
                            data={item}
                            key={index}
                            productId={id}
                            imgClick={openSetPhotoSwiper}
                            imgs={imgs}
                            language={props.language}
                            userInfo={props.userInfo}
                        />
                    ))}
                </div>
            ) : (
                <>
                    {/* 没有评论的空状态 */}
                    <div className={stl["no-review-container"]}>
                        {t("review:WelcomeToLeave")}
                    </div>
                </>
            )}
        </ProductAnswerClient>
    );
};

const WrapperProductAnswer = WithPhotoSwiper<IProps>(ProductAnswer)();
export default WrapperProductAnswer;
